import React from "react";
import Link from "next/link";
import { useSelector } from "react-redux";
import Navbar from "../components/Navbars/AppNavbar.js";
import Footer from "../components/Footers/Footer.js";
import FooterSM from "../components/Footers/FooterSmall.js";
import Auction from '../components/auctionrules';
import Head from "next/head";
import {NextSeo} from "next-seo";
import Storyblok from "../lib/storyblok"


export default function HelpUs(props) {
    const userDataRedux = useSelector((state) => state.authReducer.userData);
    const SEO = {
      title:'MusicArt | Auction Rules',
      // description:'We will contact you back vi email',
      canonical : 'https://musicart.io/auction-tules'
    }

    return (
        <>
           
    <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
            <link rel="canonical" href="https://musicart.io/auction-rules" />
    </Head>
    {props.allcomp && props.allcomp.seo_metatags && (
       <>
         <NextSeo
           title={`${props.allcomp.seo_metatags.title}`}
           description={props.allcomp.seo_metatags.description}
           og_description={props.allcomp.seo_metatags.og_description}
           og_image={props.allcomp.seo_metatags.og_image}
           og_title={props.allcomp.seo_metatags.og_title}
           twitter_description={props.allcomp.seo_metatags.twitter_description}
           twitter_image={props.allcomp.seo_metatags.twitter_image}
           twitter_title={props.allcomp.seo_metatags.twitter_title}
          
         />

         
       </>
     )} 

            <Navbar transparent />
           
            <Auction  auction={props.auction && props.auction} allcomp={props.allcomp && props.allcomp} />
            <Footer />
            <FooterSM />
        </>
    );
}

export async function getStaticProps(context) {
  // the slug of the story
  let slug = "home"
  // the storyblok params
  let params = {
    version: "draft", // or 'published' / ' draft
  }

  // checks if Next.js is in preview mode
  if (context.preview) {
    // loads the draft version
    params.version = "draft"
    // appends the cache version to get the latest content
    params.cv = Date.now()
  }

  let story = await Storyblok.get(`cdn/stories/auction-rules`,params);
  let auction = story.data.story.content.body;
  let allcomp=story.data.story.content;
 
  // return the story from Storyblok and whether preview mode is active
  return {
    props: {
      auction: auction,
      allcomp:allcomp,
      allprops:story,
      preview: context.preview || false
    },
    revalidate: 10,
  }
}
